<div class="rounded-3xl">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-4xl divide-y divide-white/10">
            @for(item of componentModel.questions.value; track $index){
                <dl class="mt-10 space-y-6 divide-y divide-white/10">
                    <white-label-faq-item [question]="item" (closeAll)="openItem($event)"></white-label-faq-item>
                </dl>
            }

        </div>
    </div>
</div>
